// Natural-key labels for the records a change item can target, shared by
// ModificationCenter's rows and the review-item panel so a reviewer reads one
// name for one record in both places.
// Humanize a period's natural key into the name the Periods table shows. The
// accept set mirrors pangaea's parsePeriodNaturalKey (case-insensitive "base" /
// "option:N" for N >= 1) and the labels come from its derivePeriodsFromKeys
// (services/pangaea/pkg/repository/delivery_aggregate_repository.go).
//
// Anything else still gets a label rather than being dropped: an empty id is
// the targetless shape pangaea warning-skips at apply, and a row id is a period
// we can't name — both are items the reviewer has to see exist.
export function periodLabel(key) {
    const k = key.trim();
    if (!k) return 'Unattributed period';
    const lower = k.toLowerCase();
    if (lower === 'base') return 'Base Period';
    if (lower.startsWith('option:')) {
        const n = Number(lower.slice('option:'.length));
        if (Number.isInteger(n) && n > 0) return `Option Period ${n}`;
    }
    return `Period ${k}`;
}
// Humanize an OptionalTask's target id into a label. This only echoes the
// number baltigo extracted — no canonical task name is loaded here. An absent
// id still gets a label rather than being dropped.
export function optionalTaskLabel(key) {
    const k = key.trim();
    if (!k) return 'Unattributed optional task';
    return `Optional Task ${k}`;
}
const USD_CENTS = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
// The one Delivery money formatter: cents always, to match the award document
// (e.g. "$1,125,619.20").
export function formatMoney(amount) {
    return USD_CENTS.format(amount);
}
